import styled from 'styled-components';

const FullScreenOverlay = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export default FullScreenOverlay;
